import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import ApiObjectType from '@/api/identityProvider/object-type'
import ObjectTypeModel from '@/model/identity-provider/application'

export default {  
    mixins: [ FormMixin, DateMixin ], 
    data(){
        return {
            rules:{
                uniqueCode: [
                    val => {
                        if((val || null) == null)
                            return this.ruleCodigoUnico;

                        return true;
                    }
                ],                               
                description: [
                    val => {
                        if((val || null) == null)
                            return this.ruleDescricao;

                        return true;
                    }
                ]
            },
            lista:{
                objectType: []
            },
            objectType: new ObjectTypeModel().returnModel()
        }
    }, 
    computed: {  
        title () {
            return this.$t('Views.ControleAcesso.TipoObjeto.Listar.form-title')
        },
        inputCodigoUnico(){
            return this.$t('Views.ControleAcesso.TipoObjeto.Editar.codigo-unico')
        },
        inputDescricao(){
            return this.$t('Views.ControleAcesso.TipoObjeto.Editar.descricao')            
        },
        ruleCodigoUnico(){
            return this.$t('Views.ControleAcesso.TipoObjeto.Editar.rule-codigo-unico')            
        },
        ruleDescricao(){
            return this.$t('Views.ControleAcesso.TipoObjeto.Editar.rule-descricao')            
        }                                                     
    },
}